import { render, staticRenderFns } from "./TableCellFormattedText.vue?vue&type=template&id=551ce250"
import script from "./TableCellFormattedText.vue?vue&type=script&lang=js"
export * from "./TableCellFormattedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports